import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RequestTypesKeys } from '@app/enums/RequestTypes';
import { TravelRequestStatusChangeModalContentComponent } from '@app/v2/components/dialogs/request-status-change-modal/travel/travel-request-status-change-modal-content/travel-request-status-change-modal-content.component';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { BaseCellEditorComponent } from '../base-cell-editor/base-cell-editor.component';
import { getModalConfig, ModalSize } from '@utility/modal-helper';
import { TravelRequestStatusChangeFormGroup } from '@app/v2/components/dialogs/request-status-change-modal/travel/travel-request-status-change-modal-content/travel-request-status-change-modal-content.form';
import { ExpenseTrackingService, RequestControllerv2Service } from '@app/generated-api';
import { RequestStatus, TravelRequestStatus } from '@models/request';
import { Observable } from 'rxjs';

@Component({
    selector: 'medpace-travel-request-status-change-modal-cell-editor',
    imports: [TravelRequestStatusChangeModalContentComponent],
    standalone: true,
    templateUrl: './travel-request-status-change-modal-cell-editor.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelRequestStatusChangeModalCellEditorComponent<TContext = any> extends BaseCellEditorComponent<
    StudyExpenseTrackingDataRow,
    number,
    TContext,
    {
        requestData: {
            requestId: number;
            patientId: number;
        };
    }
> {
    generatedRequestService = inject(RequestControllerv2Service);
    generatedExpenseTrackingService = inject(ExpenseTrackingService);
    formGroup = new TravelRequestStatusChangeFormGroup();

    modalConfig = getModalConfig(ModalSize.Small);

    cancel() {
        this.baseParams().api.stopEditing(true);
    }
    confirm(formGroup: TravelRequestStatusChangeFormGroup) {
        const customParams = this.customParams();
        const value = formGroup.value;

        const request: Observable<any> = (() => {
            if (value.newStatusId === TravelRequestStatus.PendingInvoice) {
                return this.generatedExpenseTrackingService.expenseTrackingCompleteTravelRequest({
                    requestId: customParams.requestData.requestId,
                    patientId: customParams.requestData.patientId,
                    status: <RequestStatus>{ statusId: value.newStatusId },
                    additionalDetails: value.additionalInfo,
                    newStatus: TravelRequestStatus[value.newStatusId].toString(),
                    requestType: RequestTypesKeys.TRAVEL,
                });
            } else {
                return this.generatedRequestService.requestControllerv2ChangeRequestStatus({
                    requestId: customParams.requestData.requestId,
                    additionalDetails: value.additionalInfo,
                    newStatus: TravelRequestStatus[value.newStatusId].toString(),
                    requestType: RequestTypesKeys.TRAVEL,
                });
            }
        })();

        return request.subscribe({
            error: (e) => {
                this.baseParams().api.stopEditing(true);
            },
            complete: () => {
                this.baseParams().api.stopEditing(false);
                const comp = <any>this.baseParams().context; //circular dependecy, thats why any
                comp.loadData();
            },
        });
    }

    getValue(): number | null {
        return this.formGroup.controls.newStatusId.value;
    }
}
